import React from "react";
import { Box, Button, Typography } from "@mui/material";
import MaleFullIcon from "../assets/icons/male_full_icon.svg";
import FemaleFullIcon from "../assets/icons/female_full_icon.svg";
import MaleGreyIcon from "../assets/icons/male_grey_icon.svg";
import FemaleGreyIcon from "../assets/icons/female_grey_icon.svg";
import { useBrandAppearance } from "../hooks/useBrandAppearance";

interface GenderToggleProps {
    gender: string;
    onChange: (gender: "male" | "female") => void;
    disabled?: boolean;
}

const GenderToggle: React.FC<GenderToggleProps> = ({ gender, onChange, disabled = false }) => {

    const { colors: BrandColors, isDark } = useBrandAppearance();
    const normalizedGender = gender?.toLowerCase();
    const selectedGender =
        normalizedGender === "female" ? "female" :
            normalizedGender === "male" ? "male" : "male";

    return (
        <Box sx={{ display: "flex", gap: "2px", opacity: disabled ? 0.5 : 1 }}>
            {/* Male Button */}
            <Button
                onClick={() => !disabled && onChange("male")}
                disabled={disabled}
                sx={{
                    width: "80px",
                    height: "55px",
                    pb: 0,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "transparent",
                    border:
                        selectedGender === "male"
                            ? `2px solid ${BrandColors.genderToggleBtn}`
                            : `1px solid ${isDark ? "rgba(255,255,255,0.28)" : "#E0E0E0"}`,
                    borderRadius: "5px",
                    cursor: disabled ? "default" : "pointer",
                }}
            >
                <Typography
                    variant="body2"
                    sx={{
                        fontWeight: "bold",
                        color:
                            selectedGender === "male"
                                ? isDark
                                    ? "var(--oc-text)"
                                    : "#000"
                                : isDark
                                  ? "rgba(255,255,255,0.55)"
                                  : "#777",
                        mb: 0.5,
                    }}
                >
                    MALE
                </Typography>
                <Box
                    component="img"
                    src={selectedGender === "male" ? MaleFullIcon : MaleGreyIcon}
                    alt="Male Icon"
                    sx={{
                        width: "24px",
                        height: "24px",
                        ...(isDark
                            ? {
                                  filter: "brightness(0) invert(1)",
                                  opacity: selectedGender === "male" ? 1 : 0.65,
                              }
                            : {}),
                    }}
                />
            </Button>

            {/* Female Button */}
            <Button
                onClick={() => !disabled && onChange("female")}
                disabled={disabled}
                sx={{
                    width: "80px",
                    height: "55px",
                    pb: 0,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "transparent",
                    border:
                        selectedGender === "female"
                            ? `2px solid ${BrandColors.genderToggleBtn}`
                            : `1px solid ${isDark ? "rgba(255,255,255,0.28)" : "#E0E0E0"}`,
                    borderRadius: "5px",
                    cursor: disabled ? "default" : "pointer",
                }}
            >
                <Typography
                    variant="body2"
                    sx={{
                        fontWeight: "bold",
                        color:
                            selectedGender === "female"
                                ? isDark
                                    ? "var(--oc-text)"
                                    : "#000"
                                : isDark
                                  ? "rgba(255,255,255,0.55)"
                                  : "#777",
                        mb: 0.5,
                    }}
                >
                    FEMALE
                </Typography>
                <Box
                    component="img"
                    src={selectedGender === "female" ? FemaleFullIcon : FemaleGreyIcon}
                    alt="Female Icon"
                    sx={{
                        width: "24px",
                        height: "24px",
                        ...(isDark
                            ? {
                                  filter: "brightness(0) invert(1)",
                                  opacity: selectedGender === "female" ? 1 : 0.65,
                              }
                            : {}),
                    }}
                />
            </Button>
        </Box>
    );
};

export default GenderToggle;
